'use client'

import { Common } from '@/config/NextImport'
import useScreenWidth from '@/hooks/useScreenWidth'
import { useState } from 'react'
import SafeImage from '../common/SafeImage'

const ProductImages = (props: any) => {
  const screenWidth = useScreenWidth()
  const [isShow360Video, setIsShow360Video] = useState<boolean>(false)
  const [isShow360VideoPopup, setIsShow360VideoPopup] = useState<any>(false)

  const changeProductImage = (e: any, image: any) => {
    e.preventDefault()
    setIsShow360Video(false)
  }

  const show360Video = (e: any) => {
    e.preventDefault()
    setIsShow360Video(true)
    if (screenWidth <= 767) {
      setIsShow360VideoPopup(true)
    } else {
      setIsShow360VideoPopup(false)
    }
  }

  return (
    <div className="col-md-6">
      <div className="left-diamond-image">
        <div className="xzoom-container">
          <div className="row ms-lg-0">
            <div className="col-lg-10 order-lg-2 xzoom-big-col">
              <div className="xzoom-big xzoom-single-diamond">
                {isShow360Video && !isShow360VideoPopup ? (
                  <iframe
                    id="framebox"
                    className="framexzoom d-none d-md-block"
                    width="500"
                    height="500"
                    src={props.data.view_360_url}
                  />
                ) : (
                  // <img
                  //   className="xzoom"
                  //   id="xzoom-default"
                  //   src={props.data.base_image}
                  //   alt="Diamond"
                  // />
                  <SafeImage
                    src={props.data.base_image}
                    altSrc={props.data?.default_image}
                    alt="Diamond"
                    id="xzoom-default"
                    className="xzoom"
                  />
                )}
              </div>
            </div>
            <div className="col-lg-2 px-0 order-lg-1  xzoom-thumbs-col">
              <div className="xzoom-thumbs">
                {/* <img
                  className={
                    !isShow360Video
                      ? 'xzoom-gallery xzoom-gallery-shape xactive'
                      : 'xzoom-gallery xzoom-gallery-shape'
                  }
                  src={props.data.base_image}
                  alt="Diamond"
                  onClick={(e) => changeProductImage(e, props.data.base_image)}
                /> */}
                <SafeImage
                  className={
                    !isShow360Video
                      ? 'xzoom-gallery xzoom-gallery-shape xactive'
                      : 'xzoom-gallery xzoom-gallery-shape'
                  }
                  src={props.data.base_image}
                  altSrc={props.data?.default_image}
                  alt="Diamond"
                  onClick={(e) => changeProductImage(e, props.data.base_image)}
                />
                {props.data.view_360_url != null && props.data.view_360_url !== '' && (
                  <img
                    className={
                      isShow360Video
                        ? 'xzoom-gallery xzoom-gallery-shape p-2 p-lg-3 xactive'
                        : 'xzoom-gallery xzoom-gallery-shape p-2 p-lg-3'
                    }
                    width="80"
                    src={Common.setImagePath('assets/images/icon/360.svg')}
                    alt="View 360"
                    onClick={(e) => show360Video(e)}
                  />
                )}
                {props.data.diamond_certificate_pdf !== null &&
                  props.data.diamond_certificate_pdf !== 'null' &&
                  props.data.diamond_certificate_pdf !== undefined &&
                  props.data.diamond_certificate_pdf !== '' && (
                    <a
                      href={props.data.diamond_certificate_pdf}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="xzoom-default"
                        width="80"
                        src={Common.setImagePath('assets/images/certificate-icon.jpg')}
                        alt="Diamond Certificate"
                      />
                    </a>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductImages
